"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6229],{

/***/ 86229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mK": function() { return /* reexport */ EmailSignUpComponent; },
  "Zz": function() { return /* reexport */ EmailSignUpToast; }
});

// UNUSED EXPORTS: EmailSignUp

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(40782);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Close.js
var Close = __webpack_require__(75271);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var src_instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Container/Container.js
var Container = __webpack_require__(32223);
// EXTERNAL MODULE: ./node_modules/next/dist/build/polyfills/fetch/index.js
var polyfills_fetch = __webpack_require__(63144);
var fetch_default = /*#__PURE__*/__webpack_require__.n(polyfills_fetch);
// EXTERNAL MODULE: ./node_modules/@pcln/email-signup/lib-esm/OptInBody.js + 2 modules
var OptInBody = __webpack_require__(7820);
// EXTERNAL MODULE: ./node_modules/@pcln/email-signup/lib-esm/SignUpComplete.js
var SignUpComplete = __webpack_require__(29820);
// EXTERNAL MODULE: ./node_modules/@pcln/email-signup/lib-esm/OptInText.js
var OptInText = __webpack_require__(39515);
// EXTERNAL MODULE: ./node_modules/@pcln/contentful-components/lib-esm/ContentfulRichText/ContentfulRichText.js + 3 modules
var ContentfulRichText = __webpack_require__(91378);
// EXTERNAL MODULE: ./node_modules/@pcln/contentful-components/lib-esm/useContentful/useContentful.js
var useContentful = __webpack_require__(61388);
// EXTERNAL MODULE: ./node_modules/@pcln/contentful-components/lib-esm/getVariantContent/getVariantContent.js
var getVariantContent = __webpack_require__(57931);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var utils_analytics = __webpack_require__(94738);
// EXTERNAL MODULE: ./src/hooks/useSeti.ts
var useSeti = __webpack_require__(39939);
// EXTERNAL MODULE: ./src/utils/is-content-ivariation-collection-type.ts
var is_content_ivariation_collection_type = __webpack_require__(51906);
;// CONCATENATED MODULE: ./src/components/EmailSignUp/customHooks/useLocalStorageToTrackOptin.ts

var useLocalStorageToTrackOptin = function() {
    var ref;
    var stateEmailOptIn =  true && JSON.parse((ref = localStorage.getItem("hideEmailOptIn")) !== null && ref !== void 0 ? ref : "{}");
    var ref1 = (0,react.useState)(!!(stateEmailOptIn === null || stateEmailOptIn === void 0 ? void 0 : stateEmailOptIn.isHidden)), hideEmailOptIn = ref1[0], setHideEmailOptIn = ref1[1];
    var onSuccess = function() {
        setHideEmailOptIn(true);
    };
    (0,react.useEffect)(function() {
        localStorage.setItem("hideEmailOptIn", JSON.stringify({
            isHidden: hideEmailOptIn
        }));
    }, [
        hideEmailOptIn
    ]);
    return {
        onSuccess: onSuccess
    };
};
/* harmony default export */ var customHooks_useLocalStorageToTrackOptin = (useLocalStorageToTrackOptin);

;// CONCATENATED MODULE: ./src/components/EmailSignUp/content.ts
/* harmony default export */ var content = ({
    headline: {
        data: {},
        content: [
            {
                data: {},
                content: [
                    {
                        data: {},
                        marks: [],
                        value: "Sign up for Exclusive Email-only Coupons",
                        nodeType: "text"
                    }
                ],
                nodeType: "paragraph"
            }
        ],
        nodeType: "document"
    },
    subheadline: {
        data: {},
        content: [
            {
                data: {},
                content: [
                    {
                        data: {},
                        marks: [],
                        value: "Exclusive access to coupons, special offers and promotions.",
                        nodeType: "text"
                    }
                ],
                nodeType: "paragraph"
            }
        ],
        nodeType: "document"
    },
    alertId: "1",
    channelType: "EMAIL",
    contactSourceType: "CS",
    buttonText: "send me deals",
    invalidEmailError: new Error("Email address is invalid"),
    url: "/partner/api/emailOptIn",
    placeholder: "example@example.com",
    successHeadline: {
        data: {},
        content: [
            {
                data: {},
                content: [
                    {
                        data: {},
                        marks: [],
                        value: "Success! New Deals are on their way to your inbox.",
                        nodeType: "text"
                    }
                ],
                nodeType: "paragraph"
            }
        ],
        nodeType: "document"
    },
    googleAnalyticsTrackingOnView: {
        action: null,
        category: null,
        label: null
    },
    googleAnalyticsTrackingOnClick: {
        action: null,
        category: null,
        label: null
    }
});

;// CONCATENATED MODULE: ./src/components/EmailSignUp/EmailSignUpComponent.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var getContentTypeId = function(isToast) {
    return isToast ? "emailOptInToastModule" : "emailOptIn";
};
function mapContentfulContent(optIn) {
    var ref;
    var _callToAction;
    var ref1 = (_callToAction = optIn.callToAction) !== null && _callToAction !== void 0 ? _callToAction : {}, url = ref1.url, label = ref1.label, analyticsTracking = ref1.analyticsTracking;
    var ref2;
    var ref3 = (ref2 = optIn === null || optIn === void 0 ? void 0 : (ref = optIn.input) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref2 !== void 0 ? ref2 : {}, placeholder = ref3.placeholder, error = ref3.error;
    var headline = optIn.headline, subheadline = optIn.subheadline, successHeadline = optIn.successHeadline, alertId = optIn.alertId, channelType = optIn.channelType, contactSourceType = optIn.contactSourceType, googleAnalyticsTracking = optIn.googleAnalyticsTracking;
    return {
        headline: headline,
        subheadline: subheadline,
        successHeadline: successHeadline,
        placeholder: placeholder,
        invalidEmailError: new Error(error),
        buttonText: label,
        url: url,
        alertId: alertId,
        channelType: channelType,
        contactSourceType: contactSourceType,
        googleAnalyticsTrackingOnView: {
            category: (googleAnalyticsTracking === null || googleAnalyticsTracking === void 0 ? void 0 : googleAnalyticsTracking.category) || "email opt-in",
            action: googleAnalyticsTracking === null || googleAnalyticsTracking === void 0 ? void 0 : googleAnalyticsTracking.action,
            label: googleAnalyticsTracking === null || googleAnalyticsTracking === void 0 ? void 0 : googleAnalyticsTracking.label
        },
        googleAnalyticsTrackingOnClick: {
            category: analyticsTracking === null || analyticsTracking === void 0 ? void 0 : analyticsTracking.category,
            action: analyticsTracking === null || analyticsTracking === void 0 ? void 0 : analyticsTracking.action,
            label: analyticsTracking === null || analyticsTracking === void 0 ? void 0 : analyticsTracking.label
        }
    };
}
var RichText = (0,styled_components_browser_esm/* default */.ZP)(ContentfulRichText/* default */.Z).withConfig({
    componentId: "sc-6bc3fa22-0"
})(_templateObject());
function EmailSignUpComponent(param) {
    var closeToast = param.closeToast, _isToast = param.isToast, isToast = _isToast === void 0 ? false : _isToast, sourceId = param.sourceId, _isToastVisibile = param.isToastVisibile, isToastVisibile = _isToastVisibile === void 0 ? false : _isToastVisibile, setiVariantHasContent = param.setiVariantHasContent, _category = param.category, category = _category === void 0 ? "" : _category;
    var optInFromContentful = (0,useContentful/* default */.Z)(getContentTypeId(isToast));
    var isVariantCollection = (0,is_content_ivariation_collection_type/* default */.Z)(optInFromContentful);
    var setiName = (0,useSeti/* default */.Z)(isVariantCollection ? optInFromContentful.experimentName : "");
    var optIn = isVariantCollection ? (0,getVariantContent/* default */.Z)(setiName, optInFromContentful) : optInFromContentful;
    var hasContentfulData = optIn != null;
    (0,react.useEffect)(function() {
        if (setiVariantHasContent) setiVariantHasContent(hasContentfulData);
    }, [
        hasContentfulData,
        setiVariantHasContent
    ]);
    var ref = hasContentfulData ? mapContentfulContent(optIn) : content, headline = ref.headline, subheadline = ref.subheadline, successHeadline = ref.successHeadline, placeholder = ref.placeholder, invalidEmailError = ref.invalidEmailError, buttonText = ref.buttonText, url = ref.url, alertId = ref.alertId, channelType = ref.channelType, contactSourceType = ref.contactSourceType, googleAnalyticsTrackingOnView = ref.googleAnalyticsTrackingOnView, googleAnalyticsTrackingOnClick = ref.googleAnalyticsTrackingOnClick;
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(false), success = ref2[0], setSuccess = ref2[1];
    var ref3 = (0,react.useState)(undefined), error = ref3[0], setError = ref3[1];
    var ref4 = (0,react.useState)(""), emailEntered = ref4[0], setEmailEntered = ref4[1];
    var ref5 = (0,react.useState)(false), fireAnalyticsOnce = ref5[0], setFireAnalyticsOnce = ref5[1];
    var onSuccess = customHooks_useLocalStorageToTrackOptin().onSuccess;
    var submitEmail = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
            var emailAddress, submission, response, body, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        emailAddress = param.emailAddress;
                        setIsLoading(true);
                        setEmailEntered(emailAddress);
                        submission = {
                            alertSubscribeList: [
                                {
                                    emailAddress: emailAddress,
                                    sourceId: sourceId,
                                    alertId: alertId,
                                    channelType: channelType,
                                    contactSourceType: contactSourceType,
                                    partnerCode: "PCLN"
                                }
                            ]
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4,
                            fetch_default()(String(url), {
                                method: "POST",
                                body: JSON.stringify(submission),
                                headers: {
                                    "content-type": "application/json"
                                }
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        if (!response.ok) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            response.json()
                        ];
                    case 3:
                        body = _state.sent();
                        if (body.success) {
                            onSuccess();
                            setSuccess(true);
                            utils_analytics/* default.fireEvent */.Z.fireEvent({
                                action: googleAnalyticsTrackingOnClick.action || "Email Confirm",
                                category: googleAnalyticsTrackingOnClick.category || category,
                                label: googleAnalyticsTrackingOnClick.label || "Thank You"
                            });
                        } else {
                            throw new Error(body.errorDesc || "Email registration failure");
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        throw new Error(response.statusText || "Email registration failure");
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        err = _state.sent();
                        if ((0,src_instanceof/* default */.Z)(err, Error)) {
                            setError(err);
                        }
                        return [
                            3,
                            7
                        ];
                    case 7:
                        setIsLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function submitEmail(_) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var fireAnalyticsOnView = function() {
            if (googleAnalyticsTrackingOnView === null || googleAnalyticsTrackingOnView === void 0 ? void 0 : googleAnalyticsTrackingOnView.action) {
                utils_analytics/* default.fireEvent */.Z.fireEvent({
                    action: googleAnalyticsTrackingOnView.action,
                    category: googleAnalyticsTrackingOnView.category,
                    label: googleAnalyticsTrackingOnView.label
                });
                setFireAnalyticsOnce(true);
            }
        };
        if (!fireAnalyticsOnce) {
            if (isToast) {
                if (isToastVisibile) fireAnalyticsOnView();
            } else {
                fireAnalyticsOnView();
            }
        }
    }, [
        googleAnalyticsTrackingOnView.action,
        googleAnalyticsTrackingOnView.category,
        googleAnalyticsTrackingOnView.label,
        isToast,
        isToastVisibile,
        fireAnalyticsOnce
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: 1080,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OptInBody/* default */.Z, {
            success: success,
            apiErrorMessage: error,
            invaildEmailErrorMessage: invalidEmailError,
            isLoading: isLoading,
            submitEmail: function(email) {
                return submitEmail(email);
            },
            buttonText: buttonText,
            placeholder: placeholder,
            borderRadius: "lg",
            formControlSize: "large",
            successTemplate: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpComplete/* default */.Z, {
                headline: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText, {
                    body: successHeadline
                }),
                subheadline: emailEntered,
                closeToast: closeToast,
                isCloseButtonShown: !!closeToast
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OptInText/* default */.Z, {
                subheadlineFontSize: 2,
                headline: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText, {
                    body: headline
                }),
                subheadline: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText, {
                    body: subheadline
                }),
                spaceBetweenHeadlines: 1
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/react-toastify/dist/ReactToastify.css
var ReactToastify = __webpack_require__(40993);
;// CONCATENATED MODULE: ./src/components/EmailSignUp/EmailSignUpToast.tsx

function EmailSignUpToast_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.Toastify__toast-container {\n    width: 100%;\n    padding: 16px;\n    position: fixed;\n    bottom: ",
        ";\n  }\n  & .Toastify__toast {\n    padding: 0px;\n    font-family: 'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  }\n  & .Toastify__toast-body {\n    margin: 0px;\n    padding: 0px;\n  }\n  & .Toastify__toast-body > div {\n    width: 100%;\n  }\n  & .Toastify__close-button > svg {\n    margin: 12px;\n  }\n"
    ]);
    EmailSignUpToast_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  margin: 8px;\n  position: absolute;\n  right: 0px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var StyledToastContainer = (0,styled_components_browser_esm/* default */.ZP)(react_toastify_esm/* ToastContainer */.Ix).withConfig({
    componentId: "sc-8d09afc9-0"
})(EmailSignUpToast_templateObject(), function(props) {
    return props.isMobile ? "0px" : "-16px";
});
var CloseButton = (0,styled_components_browser_esm/* default */.ZP)(Close/* default */.Z).withConfig({
    componentId: "sc-8d09afc9-1"
})(_templateObject1());
function EmailSignUpToast(param) {
    var sourceId = param.sourceId, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var hideEmailOptIn =  true && JSON.parse(localStorage.getItem("hideEmailOptIn") || "{}");
    var ref = (0,react.useState)(false), hideUntilRefresh = ref[0], setHideUntilRefresh = ref[1];
    var toastId = react.useRef();
    var ref1 = (0,react.useState)(false), isToastShown = ref1[0], setIsToastShown = ref1[1];
    var closeToast = function() {
        react_toastify_esm/* toast.dismiss */.Am.dismiss(toastId.current);
    };
    var ref2 = (0,react.useState)(true), showSetiVariant = ref2[0], setShowSetiVariant = ref2[1];
    (0,react.useEffect)(function() {
        var CustomCloseButton = function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                onClick: function() {
                    setHideUntilRefresh(true);
                    closeToast();
                },
                size: 24,
                title: "close",
                color: "background.text"
            });
        };
        var setiVariantHasContent = function(res) {
            setShowSetiVariant(res);
        };
        var toastEmailSignup = function() {
            toastId.current = (0,react_toastify_esm/* toast */.Am)(/*#__PURE__*/ (0,jsx_runtime.jsx)(EmailSignUpComponent, {
                closeToast: function() {
                    return closeToast();
                },
                isToast: true,
                sourceId: sourceId,
                setiVariantHasContent: setiVariantHasContent,
                isToastVisibile: isToastShown
            }), {
                closeButton: CustomCloseButton
            });
        };
        return isToastShown ? toastEmailSignup() : closeToast();
    }, [
        isToastShown,
        sourceId
    ]);
    (0,react.useEffect)(function() {
        var showAt = isMobile ? 40 : 10;
        var handleScroll = function() {
            var scrollTop = window.scrollY;
            var docHeight = document.body.offsetHeight;
            var winHeight = window.innerHeight;
            var scrollPercent = scrollTop / (docHeight - winHeight);
            var scrollPercentRounded = Math.round(scrollPercent * 100);
            if (scrollPercentRounded > showAt) {
                setIsToastShown(true);
            } else {
                setIsToastShown(false);
            }
        };
        if (!(hideEmailOptIn === null || hideEmailOptIn === void 0 ? void 0 : hideEmailOptIn.isHidden) && !hideUntilRefresh && showSetiVariant) {
            window.addEventListener("scroll", handleScroll, {
                passive: true
            });
            return function() {
                window.removeEventListener("scroll", handleScroll);
            };
        }
    }, [
        hideEmailOptIn === null || hideEmailOptIn === void 0 ? void 0 : hideEmailOptIn.isHidden,
        hideUntilRefresh,
        isMobile,
        showSetiVariant
    ]);
    return showSetiVariant ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledToastContainer, {
            position: "bottom-center",
            autoClose: false,
            newestOnTop: false,
            closeOnClick: false,
            rtl: false,
            pauseOnFocusLoss: false,
            draggable: false,
            limit: 1,
            transition: react_toastify_esm/* Slide */.Mi,
            isMobile: isMobile
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: " "
    });
}

// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/isomorphic-config/lib/config.js
var config = __webpack_require__(82197);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./src/components/EmailSignUp/signup-content.ts
var signup_content_CONTENT = {
    successMessage: "Thanks for signing up!",
    merchandisingMessage: "Sign up for email-only coupons, special offers and promotions — exclusively from Priceline.",
    placeHolder: "example@address.com",
    errorMessage: "Please enter a valid email",
    buttonText: "Send me deals",
    buttonSubmittingText: "Submitting"
};
var signup_content_EMAIL_REGEXP = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(37138);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/react-hook-form.es.js
var react_hook_form_es = __webpack_require__(63523);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Input/Input.js
var Input = __webpack_require__(84498);
// EXTERNAL MODULE: ./src/constants/analytics.ts
var constants_analytics = __webpack_require__(66487);
;// CONCATENATED MODULE: ./src/components/EmailSignUp/EmailSignUpForm.tsx

function EmailSignUpForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  ",
        " {\n    display: inline-block;\n    width: auto;\n  }\n\n  ",
        " {\n    display: flex;\n  }\n"
    ]);
    EmailSignUpForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EmailSignUpForm_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    margin-left: 0;\n  }\n\n  ",
        " {\n    margin-left: ",
        "px;\n  }\n"
    ]);
    EmailSignUpForm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline;\n  height: 48px;\n  width: 308px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var EmailBannerWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c3b1d11b-0"
})(EmailSignUpForm_templateObject(), (0,index_esm/* themeGet */.R)("mediaQueries.md"), (0,index_esm/* themeGet */.R)("mediaQueries.xxl"));
var EmailFormWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c3b1d11b-1"
})(EmailSignUpForm_templateObject1(), (0,index_esm/* themeGet */.R)("mediaQueries.md"), (0,index_esm/* themeGet */.R)("mediaQueries.xxl"), (0,index_esm/* themeGet */.R)("space.4"));
var EmailInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-c3b1d11b-2"
})(_templateObject2());
function EmailSignUpForm_EmailSignUpForm(param) {
    var category = param.category, children = param.children, apiError = param.apiError, submitEmail = param.submitEmail, isLoading = param.isLoading;
    // eslint-disable can be removed after upgrade to react-hook-form v7 - https://github.com/react-hook-form/react-hook-form/issues/2887
    // eslint-disable-next-line @typescript-eslint/unbound-method
    var ref = useForm({
        mode: "onSubmit"
    }), errors = ref.errors, handleSubmit = ref.handleSubmit, register = ref.register;
    var errorMessage = errors.signUpPromotion ? "Please enter a valid email." : apiError === null || apiError === void 0 ? void 0 : apiError.message;
    useEffect(function() {
        analytics.fireEvent({
            action: "Email Signup",
            category: category,
            label: errorMessage ? INVALID : VALID
        });
    }, [
        category,
        errorMessage
    ]);
    return /*#__PURE__*/ _jsx("form", {
        "aria-label": "email-sign-up-form",
        onSubmit: handleSubmit(submitEmail),
        children: /*#__PURE__*/ _jsxs(EmailBannerWrapper, {
            alignItems: "center",
            justifyContent: "center",
            py: 2,
            children: [
                /*#__PURE__*/ _jsx(Box, {
                    pb: 2,
                    pt: [
                        null,
                        null,
                        2
                    ],
                    width: [
                        1,
                        null,
                        "auto"
                    ],
                    children: children
                }),
                /*#__PURE__*/ _jsxs(EmailFormWrapper, {
                    alignItems: "center",
                    justifyContent: "center",
                    ml: 4,
                    py: 2,
                    children: [
                        /*#__PURE__*/ _jsxs(Box, {
                            children: [
                                /*#__PURE__*/ _jsx(EmailInput, {
                                    "aria-label": "Promotion Input",
                                    "aria-describedby": "promotion_error",
                                    id: "signUpPromotion",
                                    name: "signUpPromotion",
                                    color: errorMessage ? "red" : "",
                                    ref: register({
                                        required: true,
                                        pattern: EMAIL_REGEXP
                                    }),
                                    placeholder: CONTENT.placeHolder
                                }),
                                /*#__PURE__*/ _jsx(Box, {
                                    id: "promotion_error",
                                    children: errorMessage && /*#__PURE__*/ _jsx(Tooltip, {
                                        bottom: true,
                                        right: true,
                                        color: "error",
                                        zIndex: 1,
                                        children: errorMessage
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            children: /*#__PURE__*/ _jsx(Button, {
                                disabled: isLoading,
                                ml: 3,
                                px: 3,
                                variation: "fill",
                                size: "large",
                                "data-testid": "email-signup-button",
                                type: "submit",
                                children: isLoading ? CONTENT.buttonSubmittingText : CONTENT.buttonText
                            })
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/EmailSignUp/EmailSignUp.tsx




function EmailSignUp_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: solid 1px transparent;\n  text-align: center;\n"
    ]);
    EmailSignUp_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var URL = (config_default()).client.email.optIn;
var EmailContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-316f1495-0"
})(EmailSignUp_templateObject());
function EmailSignUp(param) {
    var sourceId = param.sourceId, category = param.category, children = param.children;
    var ref = useState(false), isLoading = ref[0], setIsLoading = ref[1];
    var ref1 = useState(false), success = ref1[0], setSuccess = ref1[1];
    var ref2 = useState(null), error = ref2[0], setError = ref2[1];
    var submitEmail = function() {
        var _ref = _async_to_generator(function(param) {
            var signUpPromotion, submission, response, body, err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        signUpPromotion = param.signUpPromotion;
                        setIsLoading(true);
                        submission = {
                            alertSubscribeList: [
                                {
                                    emailAddress: signUpPromotion,
                                    sourceId: sourceId,
                                    alertId: 1,
                                    channelType: "EMAIL",
                                    contactSourceType: "CS",
                                    partnerCode: "PCLN"
                                }
                            ]
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4,
                            fetch(URL, {
                                method: "POST",
                                body: JSON.stringify(submission),
                                headers: {
                                    "content-type": "application/json"
                                }
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        if (!response.ok) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            response.json()
                        ];
                    case 3:
                        body = _state.sent();
                        if (body.success) {
                            setSuccess(true);
                            analytics.fireEvent({
                                action: "Email Confirm",
                                category: category,
                                event: "gtm-pageload-event",
                                label: "Thank You"
                            });
                        } else {
                            throw new Error(body.errorDesc || "Email registration failure");
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        throw new Error(response.statusText || "Email registration failure");
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        err = _state.sent();
                        if (_instanceof(err, Error)) {
                            setError(err);
                        }
                        return [
                            3,
                            7
                        ];
                    case 7:
                        setIsLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function submitEmail(_) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsx(EmailContainer, {
        color: "background.lightest",
        mb: 0,
        justifyContent: "center",
        children: success ? /*#__PURE__*/ _jsx(Text, {
            fontSize: 3,
            fontWeight: "bold",
            my: 1,
            py: 3,
            textAlign: "center",
            children: CONTENT.successMessage
        }) : /*#__PURE__*/ _jsx(EmailSignUpForm, {
            category: category,
            apiError: error,
            isLoading: isLoading,
            submitEmail: submitEmail,
            children: children
        })
    });
}

;// CONCATENATED MODULE: ./src/components/EmailSignUp/index.tsx






/***/ }),

/***/ 51906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isContentIVariationCollectionType; }
/* harmony export */ });
function isContentIVariationCollectionType(content) {
    return content !== undefined && content.experimentName != null && content.experimentName.trim() !== "";
}


/***/ })

}]);